export default {"src":"/_next/static/media/invoice-paid.42cf0d50.gif","height":500,"width":500,"blurWidth":0,"blurHeight":0};